import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

type BadgeType = 'YES_NO' | 'MAPPING_RULE';

@Component({
    selector: 'app-generic-badge-renderer',
    template: `
    <span class="badge" [ngClass]="badgeClass">
      {{ label }}
    </span>
  `,
    styles: [`
    .badge {
      display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
    width: fit-content;
    padding: 3px 16px;
    box-shadow: none;
    }

    /* YES / NO */
    .badge-yes {
      background: rgba(0, 127, 0,15%);
      color: #007F00!important;
    }

    .badge-no {
      background: rgba(215, 25, 32,15%);
      color: #D71920!important;
    }

    /* MAPPING RULE */
    .badge-auto {
      background: rgba(33, 184, 43,15%);
      color: #21B82B!important;
     border: 1px solid #21B82B;
      border-radius: 5px;
      padding: 1px 10px;
    }

    .badge-manual {
      background: rgba(113, 60, 238,15%);
      color: #713CEE!important;
      border: 1px solid #713CEE;
      border-radius: 5px;
      padding: 1px 10px;
    }

    .badge-not-mapped {
      background: rgba(237, 41, 42, 15%);
      color: #ED292A !important;
      border: 1px solid #ED292A;
      border-radius: 5px;
      padding: 1px 10px;
}
    

    .badge-default {
      background: #f5f5f5;
      color: #555;
      border: 1px solid #ddd;
    }
  `],
    standalone: false
})
export class GenericBadgeRendererComponent implements ICellRendererAngularComp {

  label = '';
  badgeClass = '';
  type!: BadgeType;

  agInit(params: any): void {
    this.type = params?.type || params?.colDef?.cellRendererParams?.type;
    this.resolveBadge(params.value);
  }

  refresh(params: any): boolean {
    this.resolveBadge(params.value);
    return true;
  }

  private resolveBadge(value: any) {
    const v = (value ?? '').toString().trim().toLowerCase();

    if (this.type === 'YES_NO') {
      if (v === 'yes' || v === 'y' || v === 'true') {
        this.label = 'Y';
        this.badgeClass = 'badge-yes';
      } else {
        this.label = 'N';
        this.badgeClass = 'badge-no';
      }
      return;
    }

    if (this.type === 'MAPPING_RULE') {
      if (v === 'auto') {
        this.label = 'A';
        this.badgeClass = 'badge-auto';
      } else if (v === 'manual') {
        this.label = 'M';
        this.badgeClass = 'badge-manual';
      }else if (v === 'true') {
        this.label = 'M';
        this.badgeClass = 'badge-auto';
      }else if (v === 'false') {
        this.label = 'NM';
        this.badgeClass = 'badge-not-mapped';
      }else {
        this.label = 'NM';
        this.badgeClass = 'badge-not-mapped';
      }
      return;
    }

    // fallback
    this.label = value || '-';
    this.badgeClass = 'badge-default';
  }
}
